import store from "../store";
import {getTotalPrice, toFixedFeatureCost} from "./helpers";
import {postSureTax} from "../api/look-api";
import {filterCartItems} from "../bvcomponents/look/lookNavigation/lookFunctions2";
import {loaderDisable, loaderEnable} from "../bvcomponents/ui/loaderView";
import {setSureTax} from "../actions/shoppingCartFunctions";

export const updateSureTax = async (withLoader = true) => {
  const {cartState, fabricatorState, paymentState, userState} = store.getState();
  const fabricatorSettings = fabricatorState.settings;
  const {shippingAddress} = paymentState;
  if (!fabricatorSettings.sureTax) {
    return
  }
  if (withLoader) {
    loaderEnable();
  }
  const totalPrice = getTotalPrice()
  const cartItemsToInclude = filterCartItems(cartState.cartItems);

  const currentDate = new Date();
  const currentYear = "" + currentDate.getFullYear();
  const currentMonth = "" + currentDate.getMonth();
  const sureTaxData = {
    "DataYear": currentYear,
    "DataMonth": currentMonth,
    "CmplDataYear": currentYear,
    "CmplDataMonth": currentMonth,
    "TotalRevenue": "" + totalPrice.materialPrice,
    "STAN": "",
    "ItemList": cartItemsToInclude.map(cartItem => {
      return {
        "Currency": fabricatorSettings.currency,
        "Revenue": toFixedFeatureCost(cartItem.cartFeature, 1),
        "CustomerNumber": "" + document.kvConfig.userId,
        "Address": {
          "PrimaryAddressLine": shippingAddress.address1 || userState.userInfo.address1,
          "SecondaryAddressLine": shippingAddress.address2 || userState.userInfo.address2,
          "County": shippingAddress.state || userState.userInfo.state,
          "City": shippingAddress.city || userState.userInfo.city,
          "State": shippingAddress.state || userState.userInfo.state,
          "PostalCode": shippingAddress.postal || userState.userInfo.postal
        }
      }
    })
  }
  console.log("updating sureTax with the following data:", sureTaxData);
  const sureTaxResponse = await postSureTax(sureTaxData);
  if (withLoader) {
    loaderDisable();
  }
  if (sureTaxResponse && sureTaxResponse.totalTax) {
    store.dispatch(setSureTax(+sureTaxResponse.totalTax));
    return true
  }
  return false
}
